import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'Workspace',
  data () {
    return {
      isLoading: {
        planUpdate: false,
        contentplans: false,
        updateWorkspace: false
      },

      firstSignIn: false,

      newPlanName: null,
      newPlanDomain: null,

      selectedWorkspaceIdToSwitch: null
    }
  },
  async mounted () {
    this.loadData()
  },
  watch: {
    async $route () {
      this.loadData()
    },
    async contentplans () {
      this.loadData()
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'workspaces',
      'activeWorkspace',
      'contentplans'
    ]),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    }
  },
  methods: {
    ...mapActions([
      'updateWorkspace'
    ]),
    ...mapMutations([
      'updateActiveWorkspace',
      'setSidebar'
    ]),
    async loadData () {
      this.isLoading.contentplans = true
      this.isLoading.contentplans = false
    },
    switchToWorkspace (workspaceId) {
      if (!workspaceId) return
      console.log(`Switching to workspace ID: ${workspaceId}`)
      const targetWorkspace = this.workspaces.find(w => w.id === workspaceId)
      if (!targetWorkspace) {
        console.error('Selected workspace not found')
        return
      }

      this.selectedWorkspaceIdToSwitch = null

      // Determine the target route based on workspace type
      let targetRouteName = 'Workspace' // Default route
      const targetParams = { workspaceId }

      if (targetWorkspace.type === 'saas') {
        targetRouteName = 'ClustererPaid' // Or appropriate default SaaS view
      }

      this.$router.push({
        name: targetRouteName,
        params: targetParams
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error('Router push error:', err)
        }
      })

      this.$router.go()
    }
  }
}
